import React from "react";

const STATUS_CLASS_MAP = {
    ["INITIATED"]: "payment-initiated",
    ["PAID"]: "payment-paid",
    ["ONHOLD"]: "payment-onhold",
    ["REJECTED"]: "payment-cancelled",
    ["CANCELLED"]: "payment-cancelled",
};

const STATUS_COLOR_MAP = {
    ["INITIATED"]: "#5C9EEB",
    ["PAID"]: "#197E23",
    ["ONHOLD"]: "#FFCE22",
    ["REJECTED"]: "#FF8A00",
    ["CANCELLED"]: "#FF8A00"
};

const StatusBadge = ({ status }) => {

    if (!status) {
        return "--";
    }

    const statusUpper = (status || "").toUpperCase();

    const className = STATUS_CLASS_MAP[statusUpper] || "payment-initiated";
    const fillColor = STATUS_COLOR_MAP[statusUpper] || "#5C9EEB";

    return <>
        <div
            className={className}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill={fillColor}
                data-name="Layer 1"
                viewBox="0 0 24 24"
            >
                <path d="M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0z"></path>
            </svg>
            {status}
        </div>
    </>
};

export default StatusBadge;